import { useMocks } from '../../shared/env';
import type { PayConfigGateway } from './PayConfigGateway';
import { HttpPayConfigGateway } from './HttpPayConfigGateway';
import { MockPayConfigGateway } from './MockPayConfigGateway';

export const payConfigGateway: PayConfigGateway = useMocks ? new MockPayConfigGateway() : new HttpPayConfigGateway();
export type { PayConfigGateway } from './PayConfigGateway';
